import React from 'react';
import { useEffect, useState, useRef } from 'react'

import { useSelector, useDispatch } from 'react-redux'
//import './assets/css/emails.css'

//import './assets/css/systemManagement.css'
import '../assets/css/systemManagement.css'
import { ProductionModel } from '../models/ProductionModel'


const ProductionAutoUploadManagement = () => {

    const [token, setToken] = useState<string | undefined>(undefined);
    const [status, setStatus] = useState<string | undefined>(undefined);
    const [shlomoProductionInProgress, setShlomoProductionInProgress] = useState<boolean>(false);
    const [myInterval, setMyInterval] = useState<any | undefined>(undefined);

    const intervalRef = useRef<NodeJS.Timeout | null>(null); // Store interval ID


    useEffect(() => {
        init();

    }, [])



    const init = async () => {

    };



    const setUserName = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
        const txt = event.currentTarget.value.trim();

    };


    const sendToken = async () => {
        
        if (token)
            new ProductionModel().SetToken(token);

    }


    const runShlomoProduction = async () => {
        
        new ProductionModel().DownloadProductionFilesSholomo();
        setShlomoProductionInProgress(true);
        startInterval()
    }



    const startInterval = async () => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(async () => {
                var _status = await new ProductionModel().GetShlomoStatus();
                setStatus(_status);
                if (_status == "סיום!") {
                    stopInterval();
                }

            }, 2000);
            console.log('Interval started');
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            console.log('Interval stopped');
        }
    };
    // documents end

    return (
        <div className='main-content rtl content-body leads-list'>
            <div >
                <div className='data-card '>
                    <div className='data-card-body flex-space-between'>
                        <div>שלמה</div>
                        <div>{shlomoProductionInProgress?"":<button className="button blue pointer" onClick={(e: any) => runShlomoProduction()}>
                            הורדת פרודוקציה
                        </button>}</div>
                        <div>{shlomoProductionInProgress && status ? status : ""}</div>
                        {/* <div><input type="text" title='טוקן'
                            onBlur={(e: any) => setToken(e.currentTarget.value.trim())}
                            onChange={(e: any) => setToken(e.currentTarget.value.trim())}
                        />
                            <button className="button blue pointer" onClick={(e: any) => sendToken()}>
                                שליחת טוקן
                            </button>
                        </div> */}
                    </div>
                </div>

            </div>

        </div>











    )
}

export default ProductionAutoUploadManagement;
export { };
